var map = {
	"./banner/MP-video-home-1920x1080.webm": 917,
	"./banner/banner.mp4": 5742,
	"./banner/banner.webm": 3765,
	"./banner/bg_homepage.png": 1593,
	"./banner/video-home.mp4": 1033,
	"./certification/DGERT.svg": 9826,
	"./certification/Logo_Inovadora 24.png": 8735,
	"./certification/Microsoft_Silver.svg": 3853,
	"./certification/NP4457.svg": 6032,
	"./certification/PME_21.svg": 7747,
	"./certification/PME_22.svg": 8978,
	"./certification/excelencia_2022.svg": 5091,
	"./certification/inovadora_2024.svg": 1664,
	"./certification/iso27001.svg": 3419,
	"./certification/iso9001.svg": 1603,
	"./clients/advance.png": 7169,
	"./clients/axians.png": 297,
	"./clients/blue_backgorund.jpg": 8024,
	"./clients/cascais.png": 7911,
	"./clients/critical.png": 172,
	"./clients/euroBic.png": 1500,
	"./clients/open.png": 3769,
	"./clients/rigor.png": 7131,
	"./financial_products/bg_financial_products.png": 6024,
	"./opportunities/bg_blue_opportunities.png": 7452,
	"./quote/bg_blue_quote.jpg": 9954,
	"./quote_video/en/quote_img.png": 3457,
	"./quote_video/equipa-match-site.jpg": 613,
	"./quote_video/pt/quote_img.png": 9911,
	"./quote_video/quote_img.png": 7643,
	"./team/beatriz_machado.png": 6006,
	"./team/bernardo_saraiva.png": 2384,
	"./team/bruna_andrade.png": 6796,
	"./team/bruna_freitas.png": 1641,
	"./team/diana_alves.png": 2921,
	"./team/felipe_pais.png": 4230,
	"./team/filipe_figueiredo.png": 3203,
	"./team/joana_almeida.png": 6112,
	"./team/leonor_felix.png": 9926,
	"./team/luis_nogueira.png": 8847,
	"./team/marta_rodrigues.png": 97,
	"./team/rita_marques.png": 2004,
	"./team/rita_rosa.png": 9241,
	"./team/sara_laranjeira.png": 5862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9445;